import { render, staticRenderFns } from "./ElementSelect.vue?vue&type=template&id=96551cce&scoped=true"
import script from "./ElementSelect.vue?vue&type=script&lang=js"
export * from "./ElementSelect.vue?vue&type=script&lang=js"
import style0 from "./ElementSelect.vue?vue&type=style&index=0&id=96551cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96551cce",
  null
  
)

export default component.exports